import * as Tooltip from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';

import { Badge } from '../ui/Badge';

interface MetricCardProps {
  label: string;
  value: string;
  delta?: string;
  tooltip?: string;
  tone?: 'danger' | 'neutral' | 'success' | 'warning';
}

export function MetricCard({ delta, label, tone, tooltip, value }: MetricCardProps) {
  return (
    <div className="rounded border border-border bg-surface p-4">
      <div className="flex items-center gap-2 text-sm text-text-muted">
        <span>{label}</span>
        {tooltip ? (
          <Tooltip.Provider delayDuration={150}>
            <Tooltip.Root>
              <Tooltip.Trigger aria-label={`${label} detail`} className="text-text-muted">
                <Info className="h-4 w-4" aria-hidden="true" />
              </Tooltip.Trigger>
              <Tooltip.Portal>
                <Tooltip.Content
                  sideOffset={6}
                  className="max-w-64 rounded bg-surface-raised px-3 py-2 text-xs text-text shadow-lg"
                >
                  {tooltip}
                  <Tooltip.Arrow className="fill-surface-raised" />
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          </Tooltip.Provider>
        ) : null}
      </div>
      {tone ? (
        <Badge className="mt-2" size="lg" tone={tone}>
          {value}
        </Badge>
      ) : (
        <div className="mt-2 text-2xl font-semibold tabular-nums">{value}</div>
      )}
      {delta ? <div className="mt-1 text-sm tabular-nums text-text-muted">{delta}</div> : null}
    </div>
  );
}
